export class AuditLog {
  constructor(
    public readonly id: string,
    public readonly userId: string,
    public readonly relationId: string,
    public readonly projectId: string,
    public readonly entityType: string,
    public readonly entityId: string,
    public readonly action: string,
    public readonly actionMetadata: PlanningItemPlannedActionMetadata|QuoteCreatedActionMetadata,
    public readonly createdAt: Date,
    public readonly updatedAt: Date
  ) {
  }

  static fromJson(json: any): AuditLog {
    return new AuditLog(
      String(json['id']),
      json['user_id'],
      json['relation_id'],
      json['project_id'],
      json['entity_type'],
      json['entity_id'],
      json['action'],
      json['action_metadata'],
      new Date(json['created_at']),
      new Date(json['updated_at'])
    )
  }
}

// NOTE: This isn't actually working as one might expect.
//
// Both of the following metadata types aren't actually 'automatically' parsed,
// the raw json object for the metadata is simply passed into the AuditLog instance.

export class PlanningItemPlannedActionMetadata {
  constructor(
    public readonly taskId: string,
    public readonly teamId: string,
    public readonly startAt: Date,
    public readonly duration: number,
    public readonly taskName: string,
    public readonly teamName: string,
  ) {
  }

  static fromJson(json: any): PlanningItemPlannedActionMetadata {
    return new PlanningItemPlannedActionMetadata(
      json['taskId'],
      json['teamId'],
      new Date(json['startedAt']),
      json['duration'],
      json['taskName'],
      json['teamName'],
    )
  }
}

export class QuoteCreatedActionMetadata {
  constructor(
    public readonly quoteNumber: string,
  ) {
  }

  static fromJson(json: any): QuoteCreatedActionMetadata {
    return new QuoteCreatedActionMetadata(
      json['quoteNumber'],
    )
  }
}
